module.exports = __webpack_public_path__ + "static/media/order-orange.3b48438a.svg";